import React from 'react'

import { RadioButton } from '../baseInputs'

const PaymentDuration = ({ ...rest }) => {
  const label = 'How many months payment break would you like to activate?'

  return (
    <div>
      <p className="font-medium my-5">{label}</p>
      <div className="radio-btn-container flex mb-5">
        <RadioButton
          errorDisabled
          name="months"
          label="1 month"
          value={1}
          {...rest}
        />
        <RadioButton
          errorDisabled
          name="months"
          label="2 months"
          value={2}
          {...rest}
        />
        <RadioButton
          errorDisabled
          name="months"
          label="3 months"
          value={3}
          {...rest}
        />
      </div>
    </div>
  )
}

export default PaymentDuration
